import { ValueModel } from "./Value.model";

export class Value extends ValueModel {
    // Add custom methods here
}
